// src/components/sections/EtTrinityPlatformHero.jsx

import React from "react";
import { motion } from "framer-motion";
import { 
    RocketLaunchIcon,
    ChatBubbleLeftRightIcon,
    ViewfinderCircleIcon,
 } from "@heroicons/react/24/outline";

// First Created – 07 Nov 2025
// Author – Atul Pandey
// Purpose – Hero section for Trinity Platform page (/trinity/platform)
// Narrative – Built from user reflections and cohort feedback to reframe Trinity’s value as a Purpose Native Performance platform for CxOs
// Updated - 25 Nov 2025 - h1 text alignment fix

export default function EtTrinityPlatformHero() {
  return (
    <section
      id="platform"
      // className="h-screen flex items-center justify-center relative bg-gradient-to-br from-gray-900 via-black to-orange-900 text-white overflow-hidden"
      // className="min-h-screen pt-20 md:pt-0 flex items-center justify-center relative bg-gradient-to-br from-gray-900 via-black to-orange-900 text-white overflow-hidden"
      className="min-h-screen w-full pt-24 md:pt-0 flex items-start md:items-center justify-center relative overflow-hidden"
    >
      {/* Subtle background pattern */}
      <div className="absolute inset-0 opacity-15 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]" />

      {/* Content */}
      <motion.div
        className="text-center z-10 px-4 max-w-4xl"
        // className="text-left md:text-left z-10 px-4 md:px-8 max-w-3xl mx-auto md:mx-0" // 25 Nov 2025
        // className="text-left md:text-left z-10 px-4 md:px-8 max-w-3xl mx-auto md:mx-0" // 25 Nov 2025
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        {/* Headline */}
        <motion.h1
          // className="text-3xl sm:text-4xl md:text-6xl font-bold mb-6 leading-normal md:leading-[1.2] space-y-1 md:space-y-0"
          className="text-3xl sm:text-4xl md:text-6xl font-bold mb-6 leading-tight md:leading-[1.1] space-y-2"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
        >
          {/* <span className="block sm:whitespace-nowrap"> */}
          <span className="block">
            Build a <span className="text-orange-500 animate-pulse">Purpose Native</span> Organization.
          </span>
          {/* <span className="block sm:whitespace-nowrap"> */}
          <span className="block">
            Elevate <span className="text-orange-400">Think & Run</span> Performance.
          </span>
        </motion.h1>

        {/* Subtext */}
        <motion.p
          className="text-lg md:text-xl text-gray-300 mb-8 max-w-4xl mx-auto"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6 }}
        >
          Trinity helps tech-led leaders orchestrate profitable growth, by connecting raw thoughts to high-performance execution, and aligning every action back to purpose.
        </motion.p>

        {/* CTA Buttons */}
        <motion.div
          className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.1 }}
        >
          <a
            href="#overview"
            className="bg-orange-600 hover:bg-orange-700 px-6 py-3 rounded-lg shadow-lg font-semibold"
          >
            <ViewfinderCircleIcon className="h-5 w-5 inline-block mr-2" />
            Explore the Platform
          </a>
          {/* <a
            href="#contact"
            className="bg-white/10 hover:bg-white/20 px-6 py-3 rounded-lg font-semibold"
          >
            <ChatBubbleLeftRightIcon className="h-5 w-5 inline-block mr-2" />
            Talk to Us
          </a> */}
          <a
            href="/trinity/meet"
            className="bg-white/10 hover:bg-white/20 px-6 py-3 rounded-lg font-semibold"
        >
            <RocketLaunchIcon className="h-5 w-5 inline-block mr-2" />
            Meet Trinity
        </a>
        </motion.div>
      </motion.div>
    </section>
  );
}
